/**
 * @generated SignedSource<<b985c64c411f37cc65551be1e0e05b6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedEmail_me$data = {
  readonly id: string;
  readonly " $fragmentType": "FeedEmail_me";
};
export type FeedEmail_me$key = {
  readonly " $data"?: FeedEmail_me$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedEmail_me">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedEmail_me",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "0c7e0b97c2061e424c15a01bd43bb225";

export default node;
